import { RootState } from "../index";
import { DashboardStateSlice } from "./dashboard.types";

export const getSlice = (state: RootState): DashboardStateSlice => state.dashboard;

export const getStatus = (state: RootState) => getSlice(state).status;
export const getUserCount = (state: RootState) => getSlice(state).userCount;
export const getDocuments30Days = (state: RootState) => getSlice(state).documents30Days;
export const getClosedDocuments6Months = (state: RootState) => getSlice(state).closedDocuments6Months;
